<div style="display:flex; flex-direction:column; justify-content:center; align-items:center">
    <div>
        <img src="../../../../assets/images/success.png" alt="">
    </div>
    <p class="import-title">Success</p>
    <p class="import-msg">Please review your new FlyCuts</p>
    <button vng-button variant="primary" (click)="navigateTo('flycuts')" class="btn-block" style="height: 40x; margin-right: 10px; width: 336px;" type="submit">View My FlyCuts</button>
</div>